<div class="tw-h-full tw-w-full tw-overflow-hidden">
  <div class="tw-flex tw-flex-col tw-h-full">
    @if ((!regimen?.class || loading) && !loadingByChild && !shouldShowAddOnInstructionUI()) {
      <loading class="tw-fixed tw-z-10 tw-top-1/2 tw-left-1/2 -tw-translate-x-1/2 -tw-translate-y-1/2"
      ></loading>
    }
    @if (loadingByChild) {
      <div class="tw-flex-1 tw-flex tw-items-center tw-justify-center tw-fixed tw-left-0 tw-right-0 tw-top-0 tw-bottom-0 tw-z-10"
        style="background: rgba(0, 0, 0, 0.5);">
        <loading></loading>
      </div>
    }
    <div class="tw-flex-1 tw-relative tw-overflow-x-hidden"
      [ngClass]="showRegimenEmptySection ? 'tw-overflow-y-hidden' : 'tw-overflow-y-auto'"
      #regimenModuleContainer="">
      @if (regimen.regimenPreparation) {
        <div
          class="tw-fixed tw-top-6 tw-left-4 tw-flex tw-items-center tw-justify-center tw-bg-black tw-rounded-xl tw-h-10 tw-w-10 tw-z-20"
          (click)="back()"
          [class.tw-absolute]="regimen && regimen.showProductSummary && regimenModuleContainer && regimen">
          <cs-icon class="tw-h-6 tw-w-6 tw-text-gray-50"
          [iconName]="'arrow_back'"></cs-icon>
        </div>
      }
      @if (!loading) {
        @if (consultationSession) {
          @if (!regimen.regimenPreparation) {
            <consultation-chat-header [consultationSession]="consultationSession"
              [regimenClass]="regimen.class"
              [botReplyInProgress]="botReplyInProgress"
              [translateChatMessages]="shouldTranslateChatMessages"
            (back)="back()"></consultation-chat-header>
          }
        } @else {
          @if (!regimen.regimenPreparation) {
            <instruction-header [title]="instructionHeaderTitle"
              [showPill]="shouldShowLanguageDropDown"
              [consultationSession]="consultationSession"
              [botReplyInProgress]="botReplyInProgress"
              [translateChatMessages]="shouldTranslateChatMessages"
            (back)="back()"></instruction-header>
          }
        }
      }
      @if (!loading){
        <toolbar-tabs class="tw-sticky tw-top-0 tw-z-10 tw-w-full"
          [ngClass]="shouldShowRegimenPreparationUI ? 'tw-hidden' : 'tw-block'"
          #toolbarTabs=""
          (tabSelected)="tabChange($event)"
          [data]="tabData"
          [hidden]="redirectAfterRegimenPreparation"
          [shouldFormatTabData]="true">
          <tab1 class="tw-uppercase"><span i18n="@@face">Face</span></tab1>
          <tab2 class="tw-uppercase"><span i18n="@@hair">Hair</span></tab2>
          <!-- Tab 3: Show Body if hasBodyRegimen, otherwise show Add-ons if showAddOnInstruction -->
          @if (hasBodyRegimen && shouldShowAddOnInstructionTab()) {
            <ng-container>
              <tab3 class="tw-uppercase"><span>Body</span></tab3>
              <tab4 class="tw-uppercase"><span i18n="@@others">Others</span></tab4>
            </ng-container>
          } @else if (!hasBodyRegimen && shouldShowAddOnInstructionTab()) {
            <tab3 class="tw-uppercase"><span i18n="@@others">Others</span></tab3>
          }
        </toolbar-tabs>
      }
      @if (tabSwitching) {
        <loading class="tw-fixed tw-z-10 tw-top-1/2 tw-left-1/2 -tw-translate-x-1/2 -tw-translate-y-1/2"></loading>
      }
      <!--chat progress bar-->
      @if (shouldShowChatProgressBar) {
        <chat-progress-bar stickyTopClass="tw-top-14"></chat-progress-bar>
      }
      @if (shouldShowAddOnInstructionUI() && !loading) {
        <user-view-instructions [addOnInstructions]="addOnInstructions()"></user-view-instructions>
      }
      @if (showRegimenEmptySection) {
        <user-view-regimen-empty [regimen]="regimen" [regimens]="regimens"></user-view-regimen-empty>
      }
      @if (shouldShowRegimenInstruction) {
        <regimen-instruction class="tw-w-full"
          [regimen]="regimen"
          [supportTicketId]="supportTicketId"
          [experiments]="experiments"
          [newInstructionUIExperiment]="newInstructionUIExperiment"
          [dietBannerV2]="dietBannerV2"
          [dietBannerRevamp]="dietBannerRevamp"
          [scrollingDown]="scrollingDown"
          (morningNightTabsVisibilityChange)="isMorningNightTabsVisibilityChange($event)"
          (reminderToggleChange)="toggleReminders($event)"
          [reminderToggle]="reminderToggle">
        </regimen-instruction>
      }
      @if (shouldShowRegimenUnpaid) {
        <user-view-regimen-unpaid class="tw-w-full tw-pb-[94px]"
          [experiments]="experiments"
          [regimen]="regimen"
          [fromPreparation]="redirectAfterRegimenPreparation"
          [isKeyboardVisible]="isKeyboardVisible"
          [isRegimenNewPropositionUI]="isRegimenNewPropositionUI"
          [unpaidUserDoctorCalls]="unpaidUserDoctorCalls"
          [scrollContainer]="regimenModuleContainer"
          (buyNow)="buyRegimen()"
          (cartChange)="updatePrice($event)"
          (updateRegimen)="updateRegimen($event)"
          (parentLoading)="parentLoading($event)"
          (selectedPlanEmit)="selectedPlan($event)"
        (doctorCallCreated)="fetchUnpaidUserDoctorCalls()"></user-view-regimen-unpaid>
      }
      @if (shouldShowRegimenConsultationView) {
        <user-view-regimen-consultation class="w100"
          [regimen]="regimen"
          [socialProof]="socialProof"
        [experiments]="experiments"></user-view-regimen-consultation>
      }
      @if (shouldShowRegimenPreparationUI) {
        <user-view-regimen-preparation class="tw-w-full"
          [regimen]="regimen"
          (showRegimen)="resetFlagAndShowRegimen()"
        (hideToolBars)="redirectAfterRegimenPreparation = true"></user-view-regimen-preparation>
      }
      @if (shouldShowConsultationPage) {
        <chatV2-view
          [hideNavBar]="true"
          [chatScrollErrorY]="headerHeight"
          (chatScrollPossible)="autoScrollToBottom()"
          title="Consultation"
          [chatUniqueObject]="consultationSession"
          [where]="{ user, consultationSession }"
          (chatLoadingStatus)="handleLoadingStatus($event)"
          (botReplyInProcessChange)="botReplyInProcessChange($event)"
        dataFunctionName="findConsultationSessionChat"></chatV2-view>
      }
    </div>
    <!--    reminder toggle container-->
    @if (!loading && regimen && showReminderContainer && regimen.showProductSummary && newInstructionUIExperiment && (regimen.class === 'FACE') && (user?.get('orderState') === appConfig.Shared.User.OrderState.DELIVERED) && !consultationSession && !showRegimenExpiryBanner && !shouldShowAddOnInstructionUI()) {
      <div
        class="">
        @if (!reminderEventSent && !isMorningNightTabsVisible) {
          <div
            class="tw-flex tw-items-center tw-justify-between tw-w-full tw-min-h-12 tw-bg-teal-300 tw-p-2 tw-px-4">
            <h2 class="tw-font-body tw-flex-1 tw-text-200"
              i18n="@@getRemindersInstruction"><span class="tw-font-bold">Get reminders</span> for product application
        </h2>
            <div class="tw-flex tw-items-center tw-justify-end tw-gap-2">
              <!-- Toggle Switch -->
              <div class="tw-relative tw-inline-block tw-w-10 tw-select-none tw-mb-[-7px]">
                <input type="checkbox"
                  name="toggle"
                  id="reminderToggle"
                  class="tw-sr-only"
                  [checked]="reminderToggle"
                  (change)="onReminderToggleChange($event)">
                <label for="reminderToggle"
                  class="tw-block tw-overflow-hidden tw-h-6 tw-rounded-full tw-cursor-pointer tw-p-0.5 before:tw-content-[''] before:tw-absolute before:tw-h-5 before:tw-w-5 before:tw-rounded-full before:tw-left-0.5 before:tw-top-0.5 before:tw-transition-transform"
                   [ngClass]="{
                   'before:tw-translate-x-4 before:tw-bg-teal-600 tw-bg-white': reminderToggle,
                   'before:tw-translate-x-0 before:tw-bg-white tw-bg-gray-400': !reminderToggle
                 }">
                </label>
              </div>
              <!-- Close Button -->
              <div (click)="closeReminder()"
                class="tw-relative -tw-right-[1px]">
                <img alt="close"
                  src="/assets/icons/reminderClose.svg"
                  class="tw-w-6 tw-h-6" />
              </div>
            </div>
          </div>
        }
        @if (reminderEventSent) {
          <div
            class="tw-flex tw-items-center tw-min-h-12 tw-bg-teal-300 tw-p-2 tw-px-">
            <img class="tw-h-6 tw-w-6"
              src="/assets/gifs/instruction-reminder.gif"
              alt="loader" />
            <h2 class="tw-font-body tw-flex-1 tw-text-200 tw-w-full"
            i18n="@@weWillRemindYou">We will remind you via app notifications</h2>
          </div>
        }
      </div>
    }

    @if (!loading && regimen && regimen.showProductSummary
      && (user?.get('orderState') === appConfig.Shared.User.OrderState.DELIVERED) && !consultationSession
      && regimenExpiryExperiment && showRegimenExpiryBanner) {
      <regimen-expiry-strip [userFirstName]="userFirstName"
        [regimenExpiryBannerData]="regimenExpiryBannerData"
        [page]="'regimen'"
      (bannerClick)="handleRegimenExpiryBannerClick()"></regimen-expiry-strip>
    }

    @if ((!loading && regimen && regimen.showPriceDetail && regimen.totalSP && !regimen.regimenPreparation && !regimen.active && !regimen.orderPlaced && !isKeyboardVisible && !shouldShowAddOnInstructionUI()) || (regimen.showConsultationView && !regimen.orderPlaced && !isKeyboardVisible && !shouldShowAddOnInstructionUI())) {
      <div class="tw-flex-none tw-bg-white tw-py-5  tw-z-[11]"
        >
        <button class="tw-border-none tw-w-full tw-h-[54px] tw-relative tw-text-[#ffffff] tw-text-[18px] tw-capitalize tw-p-4 shine loop tw-overflow-visible tw-mb-2 tw-rounded-3" [ngClass]="regimenFixedCtaColors.backgroundClass"
          data-testid="kit-buy-now"
          (click)="buyRegimen()">
          <div
            class="tw-absolute tw-flex tw-items-center tw-justify-center tw-top-[-15px] tw-left-[10px]" [ngClass]="regimenFixedCtaColors.offerTextClass">
            <svg class="tw-w-[85px] tw-h-[85px] tw-relative tw-animate-spin_slow"
              xmlns="http://www.w3.org/2000/svg"
              width="64.443"
              height="67.447"
              viewBox="0 0 64.443 67.447">
              <path id="Path_23051"
                data-name="Path 23051"
                d="M87.025,208.059,79.5,203.146l-2.347-8.676a3.039,3.039,0,0,0-3.088-2.243l-8.976.449-7-5.639a3.042,3.042,0,0,0-3.817,0l-7,5.639-8.975-.449a3.031,3.031,0,0,0-3.088,2.243l-2.347,8.676-7.525,4.912a3.042,3.042,0,0,0-1.179,3.63l3.2,8.4-3.2,8.4a3.042,3.042,0,0,0,1.179,3.63l7.525,4.913,2.347,8.675a3.034,3.034,0,0,0,3.088,2.243l8.975-.449,7,5.639a3.041,3.041,0,0,0,3.817,0l7-5.639,8.976.449a3.036,3.036,0,0,0,3.088-2.243l2.347-8.675,7.525-4.913a3.042,3.042,0,0,0,1.179-3.63l-3.2-8.4,3.2-8.4A3.042,3.042,0,0,0,87.025,208.059Z"
                transform="translate(-23.961 -186.363)"
              [attr.fill]="regimenFixedCtaColors.offerBadgeColor"></path>
            </svg>
            <span
              class="tw-absolute tw-font-body tw-text-650 tw-text-white tw-z-20 tw-font-bold tw-leading-none">{{regimen.discount}}%
            <br />Off </span>
          </div>
          <span class="tw-ml-20 tw-font-lexend tw-font-bold tw-text-400 tw-leading-[20px]">
            <span [ngStyle]="{ 'font-size': user.get('languagePreference') === 'ta' || user.get('languagePreference') === 'ml' ? '12px' : '18px' }"
            i18n="@@buyNow">Buy Now</span>
            <span> &#64;</span>
            <span class="tw-text-200  tw-line-through">₹{{regimen.totalMRP}}</span>
            <span>₹{{regimen.totalSP}}</span>
          </span>
        </button>
      </div>
    }

    @if (shouldShowRegimenFooter) {
      <div class="tw-flex-none"
        [ngClass]="{'shadow': !(!loading && regimen && showReminderContainer && regimen.showProductSummary && newInstructionUIExperiment)}">
        @if (offerTimer.endTime > 0 && (!regimen.active && !regimen.orderPlaced)) {
          <div class="tw-w-full">
            <discount-timer [endTime]="offerTimer.endTime" [text]="offerTimer.title"></discount-timer>
          </div>
        }
        @if (!regimen.objectId && !consultationSession && !regimen.regimenPreparation && !newInstructionUIExperiment) {
          <div class="tw-w-full tw-p-4"
            >
            <cs-button [class]="'w100 primary'"
              [disabled]="isInternalUser"
              (callback)="triggerTreeForRegimen()">
              @if (isRegimenExpiredForPaidUser) {
                <cs-button-text class="tw-font-body" i18n="@@restartTreatment">Restart Treatment</cs-button-text>
              } @else {
                <cs-button-text class="tw-font-body"
                i18n="@@getYourTreatment">Get your treatment kit</cs-button-text>
              }
            </cs-button>
          </div>
        }
        @if (!regimen.objectId && !consultationSession && !regimen.regimenPreparation && newInstructionUIExperiment) {
          <div class="tw-w-full tw-p-4"
            >
            <cs-button class="tw-bg-teal-600 tw-rounded-full"
              [class]="'w100 primary'"
              [disabled]="isInternalUser"
              (callback)="triggerTreeForRegimen()">
              @if (isRegimenExpiredForPaidUser) {
                <cs-button-text class="tw-font-body" i18n="@@restartTreatment">Restart Treatment</cs-button-text>
              } @else {
                <cs-button-text class="tw-font-body"
                i18n="@@getYourTreatment">Get your treatment kit</cs-button-text>
              }
            </cs-button>
          </div>
        }
        @if (!regimen.active && regimen.orderPlaced && newInstructionUIExperiment && !isKeyboardVisible) {
          <div class="tw-w-full tw-py-6 tw-px-4">
            <button class="tw-w-full tw-p-4 tw-bg-teal-600 tw-text-white tw-font-lexend tw-font-bold tw-text-400 tw-leading-[20px] tw-rounded-3"
              [disabled]="isInternalUser"
              (click)="openRegimenOrderStatus()">
              <span i18n="@@checkOrderDetails">Check Order Details</span>
            </button>
          </div>
        }
        @if (!regimen.active && regimen.orderPlaced && !newInstructionUIExperiment && !isKeyboardVisible) {
          <div class="tw-w-full tw-p-4">
            <cs-button [class]="'w100 secondary'"
              [disabled]="isInternalUser"
              (callback)="openRegimenOrderStatus()">
              <cs-button-text i18n="@@checkOrderDetails">Check Order Details</cs-button-text>
            </cs-button>
          </div>
        }
        <!--      Old instruction page cta container -->
        @if (regimen.active && regimen.showProductSummary && !newInstructionUIExperiment) {
          <div class="tw-w-full tw-p-4 tw-flex tw-justify-around tw-gap-3"
            >
            <div class="tw-flex-1">
              <cs-button class="tw-border tw-rounded-full tw-border-black tw-text-green-400"
                [class]="'w100 purple btn-xs'"
                (callback)="showPriceDetails()">
                <cs-button-text i18n="@@fullDetails">Full Details</cs-button-text>
              </cs-button>
            </div>
            <div class="tw-flex-1">
              <cs-button class="tw-border tw-rounded-full tw-border-green-400"
                [class]="'w100 primary btn-xs'"
                [disabled]="isInternalUser"
                (callback)="reorder()">
                <cs-button-text i18n="@@reorder">Reorder</cs-button-text>
              </cs-button>
            </div>
          </div>
        }
        <!--      New instruction page cta container -->
        @if (regimen.active && regimen.showProductSummary && newInstructionUIExperiment) {
          <ng-container *ngTemplateOutlet="readDetailedInstructionsButton"></ng-container>
        }
        @if (regimen.active && regimen.showPriceDetail && !newInstructionUIExperiment) {
          <div class="tw-w-full tw-p-4"
            >
            <cs-button [class]="'w100 secondary'"
              [disabled]="isInternalUser"
              (callback)="showSummaryView(true)">
              <cs-button-text i18n="@@readInstructions">Read Instructions</cs-button-text>
            </cs-button>
          </div>
        }
        @if (regimen.active && regimen.showPriceDetail && newInstructionUIExperiment) {
          <div class="tw-w-full tw-h-18 tw-p-4"
            >
            <button [disabled]="isInternalUser"
              class="tw-bg-teal-600 tw-w-full tw-py-2 tw-px-6 tw-text-white tw-text-center tw-rounded-3 tw-font-body tw-font-bold tw-h-[40px]"
              (click)="showSummaryView(true)"
            i18n="@@readInstructions">Read Instructions</button>
          </div>
        }
        @if (!regimen.active && regimen.showProductSummary && !regimen.orderPlaced && !newInstructionUIExperiment && !isKeyboardVisible) {
          <div class="tw-w-full tw-p-4 tw-flex tw-justify-around tw-gap-3"
            >
            <div class="tw-flex-1">
              <cs-button class="tw-border tw-rounded-full tw-border-black tw-text-green-400"
                [class]="'w100 purple btn-xs'"
                [disabled]="isInternalUser"
                (callback)="readMoreAboutProducts()">
                <cs-button-text i18n="@@fullDetails">Full Details</cs-button-text>
              </cs-button>
            </div>
            <div class="tw-flex-1">
              <cs-button id="buyNowButton"
                [class]="isTabActive ? 'w100 primary shine btn-xs' : 'w100 primary btn-xs'"
                [disabled]="isInternalUser"
                (callback)="buyRegimen()">
                <cs-button-text i18n="@@buyNow">Buy Now</cs-button-text>
              </cs-button>
            </div>
          </div>
        }
        @if (!regimen.active && regimen.showProductSummary && !regimen.orderPlaced && !isKeyboardVisible && newInstructionUIExperiment) {
          <div class="tw-w-full tw-p-4 tw-flex tw-justify-around tw-gap-3"
            >
            <div class="tw-flex-1">
              <cs-button class="tw-border tw-rounded-full tw-border-teal-600 tw-text-teal-600"
                [class]="'w100 purple btn-xs'"
                [disabled]="isInternalUser"
                (callback)="readMoreAboutProducts()">
                <cs-button-text i18n="@@fullDetails">Full Details</cs-button-text>
              </cs-button>
            </div>
            <div class="tw-flex-1">
              <cs-button id="buyNowButton"
                class="tw-bg-teal-600 tw-rounded-full"
                [class]="isTabActive ? 'w100 primary shine btn-xs' : 'w100 primary btn-xs'"
                [disabled]="isInternalUser"
                (callback)="buyRegimen()">
                <cs-button-text i18n="@@buyNow">Buy Now</cs-button-text>
              </cs-button>
            </div>
          </div>
        }
      </div>
    }

    @if (shouldShowAddOnInstructionUI() && !loading) {
      <ng-container *ngTemplateOutlet="readDetailedInstructionsButton"></ng-container>
    }
  </div>
</div>
<ng-template #readDetailedInstructionsButton>
  <div class="tw-w-full tw-h-18 tw-p-4">
    <button class="tw-bg-teal-600 tw-w-full tw-py-2 tw-px-6 tw-text-white tw-text-center tw-rounded-3 tw-font-body tw-font-bold tw-h-[40px]"
      (click)="showPriceDetails()"
    i18n="@@readDetailedInstructions">Read Detailed Instructions</button>
  </div>
</ng-template>
